module.exports = __webpack_public_path__ + "media/images/bg/mosaic-0c59dddcd2e22b0d3b470b7f62b2516e.png";